module.exports = __webpack_public_path__ + "media/15.2080a5ba.wav";